import { api } from "@/lib/api";

// Sprint 8 — Homework (lean v1)
export const HomeworkAPI = {
  list: (params) => api.get("/homework", { params }).then((r) => r.data),
  get: (hid) => api.get(`/homework/${hid}`).then((r) => r.data),
  create: (body) => api.post("/homework", body).then((r) => r.data),
  update: (hid, patch) => api.patch(`/homework/${hid}`, patch).then((r) => r.data),
  remove: (hid) => api.delete(`/homework/${hid}`).then((r) => r.data),
  markDone: (hid, note) => api.post(`/homework/${hid}/mark-done`, { note }).then((r) => r.data),
  unmarkDone: (hid) => api.delete(`/homework/${hid}/mark-done`).then((r) => r.data),
  submissions: (hid) => api.get(`/homework/${hid}/submissions`).then((r) => r.data),
  upload: (formData) =>
    api.post("/homework/upload", formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data),
};
